// Full-canvas layout seam (no Rail/Topbar/RightRail). The page owns its own background
// (auth supplies its art column). A withBackdrop variant can be added when a second
// full-canvas consumer needs the shared <Backdrop/>.
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

const Canvas = styled.main`
  position: relative;
  min-height: 100vh;
  background: ${({ theme }) => theme.color.bgRoot};
`;

export function BareLayout() {
  return (
    <Canvas>
      <Outlet />
    </Canvas>
  );
}
